import React, { Component } from "react";
import jdenticon from 'jdenticon';
import firebase from '../Config/Firebase';

class ItemDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: true,
    };
    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, props) {
    //TODO : Refactor this code . Make it simple.
    //if the items are unassigned then make sure that they are assigned the currentLoggedInUser
    //if the items are assigned then avoid assigning the new update
    if (this.props.userAssigned === "") {
      return firebase.database().ref(`/tables/${this.props.tableID}/items/${this.props.keyID}/`).update({
        userAssigned: this.props.loggedInUser
      });
    } else {
      if (this.props.userAssigned === this.props.loggedInUser) {
        return firebase.database().ref(`/tables/${this.props.tableID}/items/${this.props.keyID}/`).update({
          userAssigned: ""
        });
      }else{
        return;
      }
    }
    //User assigned for this item. Do Nothing
    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
    e.preventDefault();
  }
  render() {
    let disabled = "";
    if(this.props.paid){
      disabled = "disabled";
    }
    jdenticon.update('.jdenticon');
    return (
      <li key={this.props.key} className={"list-group-item " + (this.props.userAssigned == this.props.loggedInUser ? 'selected-by-me' : '')} disabled={disabled} onClick={(e) => this.handleClick(this.props)}>
        {
          this.state.isToggleOn ?
            (
              <div className="itemContainer">
                {
                  this.props.userAssigned ?
                    (
                      <div className="itemUserAssigned">
                        <svg className="jdenticon img-responsive img-circle" width="40" height="40" data-jdenticon-value={this.props.userAssigned}>
                          Fallback text for browsers not supporting inline svg
                        </svg>
                      </div>
                    ) : (
                      <div className="itemUserAssigned"></div>
                    )
                }
                <div className="itemName">
                  <p>{this.props.itemName}</p>
                </div>
                <div className="itemTotal">
                  <p>${(this.props.total / 100).toFixed(2)}</p>
                </div>
                {
                  this.props.paid &&
                  <div className="paymentStatus">
                    <div className="paid">PAID</div>
                  </div>
                }
              </div>
            ) : (

              <div className="itemComtainer">
                <div className="itemUserAssigned">
                  {
                    this.props.userAssigned ?
                      (
                        <div>
                          <svg className="jdenticon img-responsive img-circle" width="40" height="40" data-jdenticon-value={this.props.userAssigned}>
                            Fallback text for browsers not supporting inline svg
                      </svg>
                        </div>
                      ) : (
                        <div>
                          <svg className="jdenticon img-responsive img-circle" width="40" height="40" data-jdenticon-value={this.props.loggedInUser}>
                            Fallback text for browsers not supporting inline svg
                      </svg>
                        </div>
                      )
                  }
                </div>
                <div className="itemName">
                  <p>{this.props.itemName}</p>
                </div>
                <div className="itemTotal">
                  <p>${(this.props.total / 100).toFixed(2)}</p>

                </div>
                {
                  this.props.paid &&
                  <div className="paymentStatus">
                    <div className="paid">PAID</div>
                  </div>
                }
              </div>
            )
        }
      </li>
    );
  }
}

export default ItemDetails;


// WEBPACK FOOTER //
// ./src/Components/ItemDetails.js